import { fetchConToken } from "../../helpers/fetch";
import { fileUpload,fileUploadStage, fileUploadStageFamiliar } from "../../helpers/fileUpload";
import { startSpinner, finishSpinner } from "../ui/spinner";
import { types } from "../../types/types";
import { documentacionFamiliarPreafiliadoChange } from "../familiarSeleccionado";
import { cambiarStadoProvisorio } from "./stateProvisorio";
import { TAMANO_IMAGENES } from "../../utils/constants";
import { fileSize } from "../../helpers/filesFunctions";
import { startAlerta } from "../ui/alertas";
export const documentacionTraerStart = () => ({
  type: types.documentacionTraerCargadaStart,
});
export const documentacionTraerError = (error) => ({
  type: types.documentacionTraerCargadaError,
  payload: error,
});
export const documentacionTraerSuccess = (payload) => {
  return {
    type: types.documentacionTraerCargadaSuccess,
    payload: payload,
  };
};
export const fetchDocumentacionAfiliacion = (idAfiliado) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    dispatch(documentacionTraerStart());
    const response = await fetchConToken(
      `DocumentacionAfiliados/${idAfiliado}`
    );
    if (!response.ok) {
      dispatch({
        type: types.documentacionTraerCargadaError,
        payload: response.statusText,
      });
      throw Error(response.statusText);
    }
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      const lista = await response.json();
      // if (lista.length > 0) {
        dispatch(documentacionTraerSuccess(lista));
      // }
    }
    dispatch(evaluarDocumentacionAfiliado());
    dispatch(finishSpinner());
  };
};

export const fetchDocumentacionStageAfiliacion = (idAfiliado) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    dispatch(documentacionTraerStart());
    const response = await fetchConToken(
      `DocumentacionAfiliadosStage/${idAfiliado}`
    );
    if (!response.ok) {
      dispatch({
        type: types.documentacionTraerCargadaError,
        payload: response.statusText,
      });
      throw Error(response.statusText);
    }
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      const lista = await response.json();
      if (lista.length >= 0) {
        dispatch(documentacionTraerSuccess(lista));
      }
    }
    dispatch(evaluarDocumentacionPreafiliado())
    dispatch(finishSpinner());
  };
};

export const fetchDocumentacionStageFamiliarAfiliacion = (idAfiliado) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    dispatch(documentacionTraerStart());
    const response = await fetchConToken(
      `DocumentacionFamiliaresStage/${idAfiliado}`
    );
    if (!response.ok) {
      dispatch({
        type: types.documentacionTraerCargadaError,
        payload: response.statusText,
      });
      throw Error(response.statusText);
    }
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      const lista = await response.json();
      if (lista.length >= 0) {
        dispatch(documentacionTraerSuccess(lista));
      }
    }
    dispatch(evaluarDocumentacionFamiliarStage())
    dispatch(finishSpinner());
  };
};


export const startUploading = (file, idTipDoc) => {

  return async (dispatch, getState) => {
    dispatch(startSpinner());
    if (file.size <= TAMANO_IMAGENES.DOCUMENTACION_AFILIADOS) {
      const state = getState();

      const { afiliado } = state.afiliacion;
      const {afiliadoEncontrado} = state.preinscripto;
      const {familiarSeleccionado,familiarAfiliadoSeleccionado} = state.familiarSeleccionado;
  
      let afiliadoORInscripto = {};
      let nuevaDocu={}
      //console.log("----------------------");
      
      if(afiliado && Object.keys(afiliado).length !==0 && Object.keys(familiarAfiliadoSeleccionado).length ===0){
        console.log("afiliado",afiliado.id_afiliado);
         afiliadoORInscripto = afiliado;
         const { id_afiliado } = afiliadoORInscripto;
          nuevaDocu = await fileUpload(file, id_afiliado, idTipDoc);
      }
      if(afiliadoEncontrado && Object.keys(afiliadoEncontrado).length !==0 && Object.keys(familiarSeleccionado).length ===0){
        console.log("preinscriptoEncontrado",afiliadoEncontrado.id_afiliado);
         afiliadoORInscripto = afiliadoEncontrado;
         const { id_afiliado } = afiliadoORInscripto;
          nuevaDocu = await fileUploadStage(file, id_afiliado, idTipDoc);
      }
  
      if(familiarSeleccionado && Object.keys(familiarSeleccionado).length !==0){
        console.log("familiarSeleccionado",familiarSeleccionado.id_afiliado);
        afiliadoORInscripto = familiarSeleccionado;
        const { id_afiliado } = afiliadoORInscripto;
         nuevaDocu = await fileUploadStage(file, id_afiliado, idTipDoc);
     }
  
     if(familiarAfiliadoSeleccionado && Object.keys(familiarAfiliadoSeleccionado).length !==0){
      console.log("familiarAfiliadoSeleccionado",familiarAfiliadoSeleccionado.id_afiliado);
      afiliadoORInscripto = familiarAfiliadoSeleccionado;
      const { id_afiliado } = afiliadoORInscripto;
       nuevaDocu = await fileUpload(file, id_afiliado, idTipDoc);
   }
  
      // DEBO TRAER EL ID_AFILIADO DEL PReinscripto
      //const { id_afiliado } = afiliadoORInscripto;
      //console.log("ddddd",id_afiliado);
      //const nuevaDocu = await fileUpload(file, id_afiliado, idTipDoc);
     // console.log("nueva docu:",nuevaDocu);
      const docuPreparada = {};
      if(nuevaDocu){
        docuPreparada.idDocumentacionAfiliado = nuevaDocu.IdDocumentacionAfiliado;
        docuPreparada.idTipoDocumentaciones = nuevaDocu.IdTipoDocumentaciones;
        docuPreparada.idAfiliado = nuevaDocu.IdAfiliado;
        docuPreparada.FechaCarga = nuevaDocu.FechaCarga;
        docuPreparada.NombreDocumento = nuevaDocu.NombreDocumento;
        docuPreparada.idDocumentacionAfiliado = nuevaDocu.IdDocumentacionAfiliado;
        docuPreparada.idTipoDocumentaciones = nuevaDocu.IdTipoDocumentaciones;
        docuPreparada.idUsuarioCarga = nuevaDocu.IdUsuarioCarga;
        docuPreparada.nombreDocumento = nuevaDocu.NombreDocumento;
        docuPreparada.urlCarpeta = nuevaDocu.UrlCarpeta;
        dispatch(startSaveDocumentacion(docuPreparada));
         if(afiliadoEncontrado && Object.keys(afiliadoEncontrado).length !==0){
           dispatch(evaluarDocumentacionPreafiliado());
         }else{
           dispatch(evaluarDocumentacionAfiliado());
         }
        if(familiarSeleccionado && Object.keys(familiarSeleccionado).length !==0){
          dispatch(evaluarDocumentacionFamiliar());
        }
        if(Object.keys(familiarAfiliadoSeleccionado).length !==0){
          dispatch(evaluarDocumentacionFamiliar());
        }
      }
    }else{
      dispatch(startAlerta(`El archivo no puede ser mayor a: ${fileSize(TAMANO_IMAGENES.DOCUMENTACION_AFILIADOS)} y el mismo tiene: ${fileSize(file.size)}`,'info'));
    }
    dispatch(finishSpinner());
  };
};
const ducumentacionStartUpdate = () => {
  return {
    type: types.documentacionStartUpdate,
  };
};

export const evaluarDocumentacionAfiliado = () => {
  //alert('evalua docu');
  return (dispatch, getState) => {
    let estado = true;
    const state = getState();
    const { items: docuAfiliacion } = state.documentacionAfiliacion;
    const afiliacion = state.afiliacion;
    const {
      items: listaDocuPorParentesco,
    } = state.tipoDocumentacionParentesco;

    const {
      items: listaDocuPorTipoAfiliacion,
    } = state.tipoDocumentacionTipoAfiliacion;

    // let arrayMixed;
    let arrayTemp = 
      (afiliacion.afiliado?.id_parentesco === 0 || afiliacion.consultaAfiliado?.id_parentesco === 0)
      ? listaDocuPorTipoAfiliacion.filter( (item2) =>
          parseInt(item2.idTipoAfiliacion) === (parseInt(afiliacion.afiliado?.id_tipo_afiliacion) || parseInt(afiliacion.consultaAfiliado?.id_tipo_afiliacion))
        )
      : listaDocuPorParentesco.filter(
          (item) => item.idParentesco === (afiliacion.afiliado?.id_parentesco || afiliacion.consultaAfiliado?.id_parentesco)
        )
    ;
    /* if(Object.keys(afiliacion.afiliado).length!==0 && Object.keys(afiliacion.consultaAfiliado).length===0){
      console.log('ebntre afiliacoin Afiliado');
      arrayMixed = [
        ...listaDocuPorParentesco.filter(
            (item) => item.idParentesco === afiliacion.afiliado?.id_parentesco
          ),
        ...listaDocuPorTipoAfiliacion.filter(
          (item2) =>
            parseInt(item2.idTipoAfiliacion) ===
            parseInt(afiliacion.afiliado?.id_tipo_afiliacion)
        ),
      ];
    }
    if(Object.keys(afiliacion.consultaAfiliado).length!==0 && Object.keys(afiliacion.afiliado).length===0){
      console.log('ebntre consulta Afiliado');
      arrayMixed = [
        ...listaDocuPorParentesco.filter(
            (item) => item?.idParentesco === afiliacion.consultaAfiliado?.id_parentesco
          ),
        ...listaDocuPorTipoAfiliacion.filter(
          (item2) =>
            parseInt(item2.idTipoAfiliacion) ===
            parseInt(afiliacion.consultaAfiliado?.id_tipo_afiliacion)
        ),
      ];
    } */

    //saco si hay duplis
    // const arrayDocumentacion = arrayMixed.filter(      //PATRICIO
    const arrayDocumentacion = arrayTemp.filter(
      (docu, index, self) =>
        index ===
        self.findIndex(
          (t) => t.idTipoDocumentaciones === docu.idTipoDocumentaciones
        )
    );

    const docuObligatoria = arrayDocumentacion.filter(
      (item) => item.obligatorio === true
    );
    
    docuObligatoria.forEach((docOblig, index) => {
      //let cont=0;
      const resu = docuAfiliacion.filter((item) => {
        // if(item.idTipoDocumentaciones===1){
        //   cont++
        // }
        return item.idTipoDocumentaciones === docOblig.idTipoDocumentaciones;
      });
      // if(docOblig.idTipoDocumentaciones === 1 && (cont<=1)){
      //   estado=false
      // }
      if( resu.length === 0){
        estado = false;
      }
    });
    dispatch(documentacionAfiliadoChange(afiliacion.afiliado?.id_sit_revista === -1 ? false : estado));
  };
};


export const evaluarDocumentacionPreafiliado = () => {
  return (dispatch, getState) => {
    let estado = true;
    const state = getState();
    const { items: docuAfiliacion } = state.documentacionAfiliacion;
    const {afiliadoEncontrado} = state.preinscripto;
    const {
      items: listaDocuPorParentesco,
    } = state.tipoDocumentacionParentesco;

    const {
      items: listaDocuPorTipoAfiliacion,
    } = state.tipoDocumentacionTipoAfiliacion;

    //console.table('evaluar docu',listaDocuPorTipoAfiliacion);
   // alert(afiliacion.afiliado?.id_tipo_afiliacion);
    const arrayMixed = [
      ...listaDocuPorParentesco.filter(
          (item) => item?.idParentesco === afiliadoEncontrado.id_parentesco
        ),
      ...listaDocuPorTipoAfiliacion.filter(
        (item2) =>
          parseInt(item2?.idTipoAfiliacion) ===
          parseInt(afiliadoEncontrado?.id_tipo_afiliacion)
      ),
    ];
    //saco si hay duplis
    const arrayDocumentacion = arrayMixed.filter(
      (docu, index, self) =>
        index ===
        self.findIndex(
          (t) => t.idTipoDocumentaciones === docu.idTipoDocumentaciones
        )
    );

    const docuObligatoria = arrayDocumentacion.filter(
      (item) => item.obligatorio === true
    );
    docuObligatoria.forEach((docOblig, index) => {
     // let cont=0;
      const resu = docuAfiliacion.filter((item) => {
        // if(item.idTipoDocumentaciones===1){
        //   cont++
        // }
        return item.idTipoDocumentaciones === docOblig.idTipoDocumentaciones;
      });
      // if(cont<=1 || cont===3){
      //   estado=false
      // }
      if( resu.length === 0){
        estado = false;
      }
    });
      dispatch(cambiarStadoProvisorio(estado));
  };
};


export const evaluarDocumentacionFamiliar = () => {
  return (dispatch, getState) => {
    let estado = true;
    const state = getState();
    const { items: docuAfiliacion } = state.documentacionAfiliacion;
    const {familiarSeleccionado,familiarAfiliadoSeleccionado} = state.familiarSeleccionado;

    let familiar ;

    if(Object.keys(familiarAfiliadoSeleccionado).length===0){
      familiar=familiarSeleccionado
    }else{
      familiar=familiarAfiliadoSeleccionado
    }
    const {
      items: listaDocuPorParentesco,
    } = state.tipoDocumentacionParentesco;

    const {
      items: listaDocuPorTipoAfiliacion,
    } = state.tipoDocumentacionTipoAfiliacion;

    // console.table('evaluar docu',listaDocuPorTipoAfiliacion);
    const arrayMixed = [
      ...listaDocuPorParentesco.filter(
          (item) => item.idParentesco === familiar.id_parentesco
        ),
      ...listaDocuPorTipoAfiliacion.filter(
        (item2) =>
          parseInt(item2.idTipoAfiliacion) ===
          parseInt(familiar?.id_tipo_afiliacion)
      ),
    ];
    //saco si hay duplis
    const arrayDocumentacion = arrayMixed.filter(
      (docu, index, self) =>
        index ===
        self.findIndex(
          (t) => t.idTipoDocumentaciones === docu.idTipoDocumentaciones
        )
    );

    const docuObligatoria = arrayDocumentacion.filter(
      (item) => item.obligatorio === true
    );
    docuObligatoria.forEach((docOblig, index) => {
      //let cont=0;
      const resu = docuAfiliacion.filter((item) => {
       // if(item.idTipoDocumentaciones===1){
          //cont++
       // }
        return item.idTipoDocumentaciones === docOblig.idTipoDocumentaciones;
      });
      // if(cont<=1 || cont===3){
      //   estado=false
      // }
      if( resu.length === 0){
        estado = false;
      }
    });
    if(Object.keys(familiarSeleccionado).length===0 && Object.keys(familiarAfiliadoSeleccionado).length===0){
      estado=false  
    }
      dispatch(documentacionFamiliarPreafiliadoChange(estado));    
  };
};

const documentacionAfiliadoChange = (payload) => {
  return {
    type: types.afiliacionesActualizarDocumentacion,
    payload: payload,
  };
};

export const documentacionAfiliadoUpdate = (
  idDocumentacionAfiliado,
  idTipoDocumentaciones
) => {
  return async (dispatch) => {
    //dispatch(startSpinner());
    dispatch(ducumentacionStartUpdate());
    const response = await fetchConToken(
      `DocumentacionAfiliados/${idTipoDocumentaciones}/${idDocumentacionAfiliado}`,
      "",
      "POST"
    );
    if (!response.ok) {
      console.log(response, idTipoDocumentaciones, idDocumentacionAfiliado);
      dispatch({
        type: types.documentacionActualizarError,
        payload: response.statusText,
      });
      //dispatch(startAlerta(`${response.statusText}`,'error',` Error en peticion API DocumentacionAfiliados/${idTipoDocumentaciones}/${idDocumentacionAfiliado}`));
      //dispatch(finishSpinner());
      throw Error(response.statusText);
    } else {
      //console.log('ok',idDocumentacionAfiliado,idTipoDocumentaciones);
      dispatch(
        documentacionAfiliadoUpdated(
          idDocumentacionAfiliado,
          idTipoDocumentaciones
        )
      );
      dispatch(evaluarDocumentacionAfiliado());
    }
    // dispatch(finishSpinner());
  };
};
export const limpiarListaDocumentacionAfiliado = () => {
  return (dispatch) => {
    dispatch({ type: types.documentacionLimpiarLista });
  };
};
export const documentacionAfiliadoDelete = (idDocumentacionAfiliado) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    const response = await fetchConToken(
      `DocumentacionAfiliados/${idDocumentacionAfiliado}`,
      "",
      "DELETE"
    );
    if (!response.ok) {
      dispatch({
        type: types.documentacionDeleteError,
        payload: response.statusText,
      });
      throw Error(response.statusText);
    } else {
      dispatch(documentacionAfiliadoDeleted(idDocumentacionAfiliado));
      dispatch(evaluarDocumentacionAfiliado());
    }
    dispatch(finishSpinner());
  };
};

export const documentacionAfiliadoDeleted = (idDocumentacionAfiliado) => ({
  type: types.documentacionDelete,
  payload: idDocumentacionAfiliado,
});
const documentacionAfiliadoUpdated = (
  idDocumentacionAfiliado,
  idTipoDocumentaciones
) => ({
  type: types.documentacionUpdated,
  payload: {
    idDocumentacionAfiliado,
    idTipoDocumentaciones,
  },
});
export const startSaveDocumentacion = (item) => {
  return {
    type: types.documentacionSubidaSuccess,
    payload: item,
  };
};
export const deleteDocumentacion = (idDocumentacionAfiliado) => {
  return {
    type: types.documentacionDelete,
    payload: idDocumentacionAfiliado,
  };
};



/*************************************************************DOCUMENTACION PREAFILIACION******************************************** */


export const documentacionStageAfiliadoDelete = (idDocumentacionAfiliado) => {
  return async (dispatch,getState) => {
    dispatch(startSpinner());
    const state = getState();

    const {familiarSeleccionado} = state.familiarSeleccionado;
    const response = await fetchConToken(
      `DocumentacionAfiliadosStage/${idDocumentacionAfiliado}`,
      "",
      "DELETE"
    );
    if (!response.ok) {
      dispatch({
        type: types.documentacionDeleteError,
        payload: response.statusText,
      });
      throw Error(response.statusText);
    } else {
      dispatch(documentacionAfiliadoDeleted(idDocumentacionAfiliado));
    }
    dispatch(evaluarDocumentacionPreafiliado());
    if(Object.keys(familiarSeleccionado).length!==0){
      dispatch(evaluarDocumentacionFamiliar());
    }
    dispatch(finishSpinner());
  };
};

export const documentacionStageAfiliadoUpdate = (
  idDocumentacionAfiliado,
  idTipoDocumentaciones
) => {
  console.log(idDocumentacionAfiliado,idTipoDocumentaciones);
  return async (dispatch,getState) => {
    //dispatch(startSpinner());
    dispatch(ducumentacionStartUpdate());
    const state = getState();
    const {familiarSeleccionado} = state.familiarSeleccionado;
    const response = await fetchConToken(
      `DocumentacionAfiliadosStage/${idTipoDocumentaciones}/${idDocumentacionAfiliado}`,
      "",
      "POST"
    );
    if (!response.ok) {
      console.log(response, idTipoDocumentaciones, idDocumentacionAfiliado);
      dispatch({
        type: types.documentacionActualizarError,
        payload: response.statusText,
      });
      throw Error(response.statusText);
    } else {
      dispatch(
        documentacionAfiliadoUpdated(
          idDocumentacionAfiliado,
          idTipoDocumentaciones
        )
      );
    }
    dispatch(evaluarDocumentacionPreafiliado());
    if(Object.keys(familiarSeleccionado).length!==0){
      dispatch(evaluarDocumentacionFamiliar());
    }
  };
};

/*************************************************************DOCUMENTACION FamiliarStage Doc PREAFILIACION******************************************** */
export const documentacionFamiliarStageDelete = (idDocumentacionAfiliado) => {
  return async (dispatch,getState) => {
    dispatch(startSpinner());
    const state = getState();

    const {familiarStagePreafiliadoSeleccionado} = state.familiarSeleccionado;
    const response = await fetchConToken(
      `DocumentacionFamiliaresStage/${idDocumentacionAfiliado}`,
      "",
      "DELETE"
    );
    if (!response.ok) {
      dispatch({
        type: types.documentacionDeleteError,
        payload: response.statusText,
      });
      throw Error(response.statusText);
    } else {
      dispatch(documentacionAfiliadoDeleted(idDocumentacionAfiliado));
    }
    if(Object.keys(familiarStagePreafiliadoSeleccionado).length!==0){
      dispatch(evaluarDocumentacionFamiliarStage());
    }
    dispatch(finishSpinner());
  };
};

export const documentacionFamiliarStageAfiliadoUpdate = (
  idDocumentacionAfiliado,
  idTipoDocumentaciones
) => {
  console.log(idDocumentacionAfiliado,idTipoDocumentaciones);
  return async (dispatch,getState) => {
    //dispatch(startSpinner());
    dispatch(ducumentacionStartUpdate());
    const response = await fetchConToken(
      `DocumentacionFamiliaresStage/${idTipoDocumentaciones}/${idDocumentacionAfiliado}`,
      "",
      "POST"
    );
    if (!response.ok) {
      console.log(response, idTipoDocumentaciones, idDocumentacionAfiliado);
      dispatch({
        type: types.documentacionActualizarError,
        payload: response.statusText,
      });
      throw Error(response.statusText);
    } else {
      dispatch(
        documentacionAfiliadoUpdated(
          idDocumentacionAfiliado,
          idTipoDocumentaciones
        )
      );
    }
    dispatch(evaluarDocumentacionFamiliarStage());

  };
};


export const startUploadingFamiliarStage = (file, idTipDoc) => {
  return async (dispatch, getState) => {
    dispatch(startSpinner());
    if (file.size <= TAMANO_IMAGENES.DOCUMENTACION_AFILIADOS) {
      const state = getState();

      const {familiarStagePreafiliadoSeleccionado} = state.familiarSeleccionado;
  
      let afiliadoORInscripto = {};
      let nuevaDocu={}
      
     if(Object.keys(familiarStagePreafiliadoSeleccionado).length !==0){
      afiliadoORInscripto = familiarStagePreafiliadoSeleccionado;
      const { id_afiliado } = afiliadoORInscripto;
       nuevaDocu = await fileUploadStageFamiliar(file, id_afiliado, idTipDoc);
   }
  
      const docuPreparada = {};
      if(nuevaDocu){
        docuPreparada.idDocumentacionAfiliado = nuevaDocu.IdDocumentacionAfiliado;
        docuPreparada.idTipoDocumentaciones = nuevaDocu.IdTipoDocumentaciones;
        docuPreparada.idAfiliado = nuevaDocu.IdAfiliado;
        docuPreparada.FechaCarga = nuevaDocu.FechaCarga;
        docuPreparada.NombreDocumento = nuevaDocu.NombreDocumento;
        docuPreparada.idDocumentacionAfiliado = nuevaDocu.IdDocumentacionAfiliado;
        docuPreparada.idTipoDocumentaciones = nuevaDocu.IdTipoDocumentaciones;
        docuPreparada.idUsuarioCarga = nuevaDocu.IdUsuarioCarga;
        docuPreparada.nombreDocumento = nuevaDocu.NombreDocumento;
        docuPreparada.urlCarpeta = nuevaDocu.UrlCarpeta;
        dispatch(startSaveDocumentacion(docuPreparada));
        dispatch(evaluarDocumentacionFamiliarStage());
      }
      
    } else {
      dispatch(startAlerta(`El archivo no puede ser mayor a: ${fileSize(TAMANO_IMAGENES.DOCUMENTACION_AFILIADOS)} y el mismo tiene: ${fileSize(file.size)}`,'info'));
    }
    dispatch(finishSpinner());
  };
};


export const evaluarDocumentacionFamiliarStage = () => {
  return (dispatch, getState) => {
    let estado = true;
    const state = getState();
    const { items: docuAfiliacion } = state.documentacionAfiliacion;
    const {familiarStagePreafiliadoSeleccionado} = state.familiarSeleccionado;

    const {
      items: listaDocuPorParentesco,
    } = state.tipoDocumentacionParentesco;

    const {
      items: listaDocuPorTipoAfiliacion,
    } = state.tipoDocumentacionTipoAfiliacion;

    // console.table('evaluar docu',listaDocuPorTipoAfiliacion);
    const arrayMixed = [
      ...listaDocuPorParentesco.filter(
          (item) => item.idParentesco === familiarStagePreafiliadoSeleccionado?.id_parentesco
        ),
      ...listaDocuPorTipoAfiliacion.filter(
        (item2) =>
          parseInt(item2.idTipoAfiliacion) ===
          parseInt(familiarStagePreafiliadoSeleccionado?.id_tipo_afiliacion)
      ),
    ];
    //saco si hay duplis
    const arrayDocumentacion = arrayMixed.filter(
      (docu, index, self) =>
        index ===
        self.findIndex(
          (t) => t.idTipoDocumentaciones === docu.idTipoDocumentaciones
        )
    );

    const docuObligatoria = arrayDocumentacion.filter(
      (item) => item.obligatorio === true
    );

    docuObligatoria.forEach((docOblig, index) => {
     // let cont=0;
      const resu = docuAfiliacion.filter((item) => {
        // if(item.idTipoDocumentaciones===1){
        //   cont++
        // }
        return item.idTipoDocumentaciones === docOblig.idTipoDocumentaciones;
      });
      // if(cont<=1 || cont===3){
      //   estado=false
      // }
      if( resu.length === 0){
        estado = false;
      }
    });
    

      dispatch(documentacionFamiliarPreafiliadoChange(estado));    
  };
};
